var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sku-button"},[_c('div',{staticClass:"tik-green"}),_c('div',{staticClass:"tik-red"}),_c('a',{staticClass:"sku-btn",style:(_vm.btnStyle),attrs:{"href":"javascript:;"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }